import * as React from 'react';

import { ModalLink, ModalRoute, useModalBack, useModalForward, useModalLocation, useModalNavigate } from 'af-components/ModalNavigation/ModalRouter';

import SearchInput from './SearchInput';
import type { RawPages, SearchPageResults, SearchablePageText } from './types';

interface Props {
	rawPages: RawPages;
	searchablePages: SearchablePageText;
	search: (text: string) => SearchPageResults | undefined;
	scrollToTop: () => void;
	getModalBodyBottomPositionForRecalculation: () => number | undefined;
}

const UserGuideModalBody: React.FC<Props> = (props) => {

	const { rawPages, searchablePages, search, scrollToTop, getModalBodyBottomPositionForRecalculation } = props;

	const modalLocation = useModalLocation();
	const navigate = useModalNavigate();
	const modalBack = useModalBack();
	const modalForward = useModalForward();
	const [searchResults, setSearchResults] = React.useState<SearchPageResults | undefined>(undefined);
	const [searchDropwdownResults, setSearchDropdownResults] = React.useState<SearchPageResults | undefined>(undefined);
	const [loadedSearchText, setLoadedSearchText] = React.useState('');

	// This enables loading searches as seperate pages when using back and forward
	React.useEffect(() => {
		const _searchText = modalLocation.split('?')[1];
		let results: SearchPageResults | undefined;
		if (_searchText) {
			results = search(_searchText);
			setLoadedSearchText(_searchText);
		} else {
			results = search('');
			setLoadedSearchText('');
		}
		setSearchDropdownResults(results);
		setSearchResults(results);
	}, [modalLocation, search]);

	const back = React.useCallback(() => {
		modalBack();
	}, [modalBack]);

	const forward = React.useCallback(() => {
		modalForward();
	}, [modalForward]);

	const filterText = React.useCallback((text: string): void => {
		setSearchDropdownResults(search(text));
	}, [search]);

	const onSearch = React.useCallback((text: string): void => {
		setSearchResults(searchDropwdownResults);
		navigate('/search' + '?' + text);
	}, [navigate, searchDropwdownResults]);

	return (
		<div className="user-guide-modal-container">
			<div className="user-guide-modal-navigation">
				<div className="user-guide-modal-navigation__actions">
					<div>
						<span className="icon-left" onClick={back}></span>
						<span className="icon-right" onClick={forward}></span>
					</div>
					<ModalLink className="home-link" link={'/'}>Home</ModalLink>
					<SearchInput
						dropdownSearchedResults={searchDropwdownResults}
						getModalBodyBottomPositionForRecalculation={getModalBodyBottomPositionForRecalculation}
						initialText={loadedSearchText}
						onFilterTextChange={filterText}
						onSearch={onSearch}
					/>
				</div>
			</div>
			<ModalRoute propsForPath={{ rawPages, searchResults, searchablePages, scrollToTop }}></ModalRoute>
		</div>
	);
};

export default UserGuideModalBody;
